import React, { useEffect, useState } from "react";
import {
  TextInput,
  Container,
  Notification,
  Group,
  Checkbox,
  Modal,
  Popover,
  MultiSelect,
} from "@mantine/core";
import "../../style/viewAppointments.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  IconArrowLeft,
  IconEdit,
  IconChevronLeft,
  IconChevronRight,
} from "@tabler/icons";
import { Button, Tooltip } from "@material-ui/core";
import { Col, Row } from "react-flexbox-grid";
import NavigoDashboardUtils from "../../services/NavigoDashboardUtils";
import { showNotification } from "@mantine/notifications";
import SearchDropdown from "react-select";
import { DatePicker } from "@mantine/dates";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { Loader } from "@mantine/core";
import filter1 from "../../assets/filter1.svg";
import filter2 from "../../assets/filter2.svg";
import paymentStatusPendingIcon from "../../assets/icons/payment/payment_status_pending.svg";
import paymentStatusPaidIcon from "../../assets/icons/payment/payment_status_paid.svg";
import paymentStatusRequestedIcon from "../../assets/icons/payment/payment_status_requested.svg";
import paymentStatusFailedIcon from "../../assets/icons/payment/payment_status_failed.svg";
import paymentStatusSponsoredIcon from "../../assets/icons/payment/payment_status_sponsored.svg";
import paymentStatusRefundedIcon from "../../assets/icons/payment/payment_status_refunded.svg";
import { getStatusName, getStatusColor } from "./statusUtils";
import {
  APPOINTMENT_PAYMENT_STATUS,
  getAppointmentPaymentStatusList,
} from "../../helper/appointmentConstants";
import PaymentLinkDialog from "./payment/PaymentLinkDialog";

export const NotificationStyles = {
  position: "fixed",
  left: "0",
  bottom: "40px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
} as React.CSSProperties;

function ViewAppointments(props: any) {
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  const [loading2, setLoading2] = useState<boolean>(false);
  const [pid, setPid] = useState<number | null>(null);
  const [pageSize, setPageSize] = useState<number>(30);
  const [pageNum, setPageNum] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [resultCount, setResultCount] = useState<number>(0);
  const [filterObj, setFilterObj] = useState<any>({});
  const [compDidMount, setCompDidMount] = useState<boolean>(false);
  const [onlyPageNext, setOnlyPageNext] = useState<boolean>(false);
  const [onlyPagePrev, setOnlyPagePrev] = useState<boolean>(false);
  const [isAppLoaded, setIsAppLoaded] = useState<boolean>(false);
  const [appIdSearch, setAppIdSearch] = useState<string>("");
  const [appointments, setAppointments] = useState<AppointmentType[]>([]);
  const [openReschAppDialog, setOpenReschAppDialog] = useState<boolean>(false);
  const [reschAppSelected, setReschAppSelected] =
    useState<AppointmentType | null>(null);
  const [appSelected, setAppSelected] = useState<AppointmentType | null>(null);
  const [serviceProviderListToShow, setServiceProviderListToShow] = useState<
    ServiceProviderOption[]
  >([]);
  const [selectServiceProviderCheckbox, setSelectServiceProviderCheckbox] =
    useState(false);
  const [serviceProviderSelected, setServiceProviderSelected] =
    useState<ServiceProviderType | null>(null);
  const [dateSelected, setDateSelected] = useState<Date | null>(null);
  const [slotList, setSlotList] = useState<SlotOption[]>([]);
  const [slotSelected, setSlotSelected] = useState<SlotOption | null>(null);
  const [homeSampleDateMin, setHomeSampleDateMin] = useState<number | null>(
    null,
  );
  const [homeSampleDateMax, setHomeSampleDateMax] = useState<number | null>(
    null,
  );
  const [serviceProviderAutoSelected, setServiceProviderAutoSelected] =
    useState<number | null>(null);
  const [vendor, setVendor] = useState<string>("");
  const [vendorCode, setVendorCode] = useState<string>("");
  const [vendorDrId, setVendorDrId] = useState(0);
  const [totalModes, setTotalModes] = useState<string[]>([]);
  const [filteredModes, setFilteredModes] = useState<string[]>([]);
  const [dateF1, setDateF1] = useState<Date | null>(null);
  const [dateF2, setDateF2] = useState<Date | null>(null);
  const [dateFilterOpened, setDateFilterOpened] = useState<boolean>(false);
  const [totalServiceCodes, setTotalServiceCodes] = useState<
    ServiceCodeOption[]
  >([]);
  const [filteredServiceCodes, setFilteredServiceCodes] = useState<string[]>(
    [],
  );
  const [searchedServiceCode, setSearchedServiceCode] = useState("");

  const [totalServiceProviders, setTotalServiceProviders] = useState<
    ServiceProvidersOption[]
  >([]);
  const [filteredServiceProviders, setFilteredServiceProviders] = useState<
    string[]
  >([]);
  const [searchedServiceProvider, setSearchedServiceProvider] = useState("");
  const [languagesList, setLanguagesList] = useState<string[]>([]);
  const [languagesSelected, setLanguagesSelected] = useState<string[]>([]);
  const [statesLocs, setStatesLocs] = useState<LocOption[]>([]);
  const [stateSelected, setStateSelected] = useState<string | null>(null);
  const [cityLocs, setCityLocs] = useState<LocOption[]>([]);
  const [citySelected, setCitySelected] = useState<string | null>(null);
  const [localityLocs, setLocalityLocs] = useState<LocOption[]>([]);
  const [localitySelected, setLocalitySelected] = useState<string | null>(null);
  const [updatePatientInfoDialog, setUpdatePatientInfoDialog] =
    useState<boolean>(false);
  const [loadingProfileUpdate, setLoadingProfileUpdate] =
    useState<boolean>(false);
  const [patientInfo, setPatientInfo] = useState<PatientInfo | null>(null);
  const [newDob, setNewDob] = useState<Date | null>(null);
  const [newEmail, setNewEmail] = useState<string>("");
  const [labelToValueMap, setLabelToValueMap] = useState<
    Record<string, string[]>
  >({});
  const [availCareDateMin, setAvailCareDateMin] = useState<number | null>(null);
  const [availCareDateMax, setAvailCareDateMax] = useState<number | null>(null);
  const [totalPayStatus, setTotalPayStatus] = useState<PayStatusOption[]>([]);
  const [filteredPayStatus, setFilteredPayStatus] = useState<string[]>([]);
  const [searchedPayStatus, setSearchedPayStatus] = useState("");
  const [showPaymentLinkDialog, setShowPaymentLinkDialog] =
    useState<boolean>(false);
  const [aptSelectedForPayment, setAptSelectedForPayment] =
    useState<AppointmentType | null>(null);
  const [patientInfoForPayment, setPatientInfoForPayment] =
    useState<PatientInfoForPayment | null>(null);
  const navigoDashboardUtils = new NavigoDashboardUtils();
  const MODES_WITH_AUTO_SP = [
    "Video consultation",
    "Tele consultation",
    "Home sample",
  ];
  const APOLLO_VENDOR_CODE = "ApolloClinic";

  dayjs.extend(utc);
  useEffect(() => {
    getModes();
    fetchServiceCodes("");
    fetchServiceProviders("");
    setTotalPayStatus(() => {
      return getAppointmentPaymentStatusList().map((item) => ({
        label: item.label,
        value: String(item.id),
      }));
    });
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");

    const isPositiveInteger = (value: any) => {
      const num = Number(value);
      return Number.isInteger(num) && num > 0;
    };

    if (!isPositiveInteger(id)) {
      showNotification({
        title: "Invalid patient ID:",
        message: "",
        color: "red",
      });
    } else {
      setPid(Number(id));
      checkPidStatus(String(id));
    }
  }, []);

  let navigate = useNavigate();

  const checkPidStatus = (id: string) => {
    const onResponse = (res: any) => {
      if (res != null && res.status != 3) {
        setCompDidMount(true);
        // getAppointments(res.id);
        setFilterObj({
          pageNum: pageNum,
          pageSize: pageSize,
          patientId: Number(res.id),
          includeAppointmentPayments: true,
          status: [0, 1, 4, 5, 6, 7, 8, 9, 10, 16, 17, 18, 19, 20, 22],
        });
      }
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in fetching patient status:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.checkPidStatus(id, onResponse, onError);
  };
  useEffect(() => {
    if (compDidMount && onlyPageNext) {
      setFilterObj({ ...filterObj, pageNum: pageNum + 1 });
      setPageNum((prev) => prev + 1);
      setOnlyPageNext(false);
    }
  }, [onlyPageNext]);
  useEffect(() => {
    if (compDidMount && onlyPagePrev) {
      setFilterObj({ ...filterObj, pageNum: pageNum - 1 });
      setPageNum((prev) => prev - 1);
      setOnlyPagePrev(false);
    }
  }, [onlyPagePrev]);

  useEffect(() => {
    if (compDidMount) {
      setFilterObj({ ...filterObj, serviceMode: filteredModes });
    }
  }, [filteredModes]);

  useEffect(() => {
    if (compDidMount) {
      setFilterObj({
        ...filterObj,
        serviceID: filteredServiceCodes.map((e: string) => Number(e)),
      });
    }
  }, [filteredServiceCodes]);

  useEffect(() => {
    if (compDidMount) {
      setFilterObj({
        ...filterObj,
        paymentStatus: filteredPayStatus.flatMap((e: string) => {
          const val = Number(e);

          if (val === APPOINTMENT_PAYMENT_STATUS.FAILED) {
            return [
              APPOINTMENT_PAYMENT_STATUS.FAILED,
              APPOINTMENT_PAYMENT_STATUS.LINK_EXPIRED,
              APPOINTMENT_PAYMENT_STATUS.LINK_CANCELLED,
            ];
          }

          return val;
        }),
      });
    }
  }, [filteredPayStatus]);
  // useEffect(() => {
  //   if (compDidMount) {
  //     setFilterObj({
  //       ...filterObj,
  //       serviceProviderID: filteredServiceProviders.map((e: string) =>
  //         Number(e)
  //       ),
  //     });
  //   }
  // }, [filteredServiceProviders]);
  useEffect(() => {
    if (compDidMount) {
      const allSelectedIDs = filteredServiceProviders.flatMap((label) => {
        return labelToValueMap[label] ?? [];
      });

      setFilterObj({
        ...filterObj,
        serviceProviderID: allSelectedIDs.map(Number),
      });
    }
  }, [filteredServiceProviders]);

  useEffect(() => {
    if (compDidMount) {
      getAppointments();
    }
  }, [filterObj]);
  const getAppointments = () => {
    setLoading(true);
    let body = filterObj;
    const onResponse = (res: AppResponseType | null) => {
      setIsAppLoaded(true);

      setLoading(false);
      if (
        res === null ||
        res.appointments === null ||
        res.appointments.length === 0
      ) {
        setAppointments([]);
        setTotalCount(0);
        if (res?.appointments === null || res?.appointments.length === 0) {
          showNotification({
            title: "No appointment found",
            message: "",
            color: "red",
          });
        }
      } else {
        setAppointments(res.appointments);
        setTotalCount(res.totalCount);
        setResultCount(res.resultCount);
      }
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in fetching appointments:",
        message: err?.message,
        color: "red",
      });
      setLoading(false);
    };
    navigoDashboardUtils.getAppointments(body, onResponse, onError);
  };

  useEffect(() => {
    if (dateF1 == null && filterObj?.appointmentDate?.from != null) {
      setFilterObj({
        ...filterObj,
        appointmentDate: { ...filterObj.appointmentDate, from: null },
      });
    }
  }, [dateF1]);
  useEffect(() => {
    if (dateF2 == null && filterObj?.appointmentDate?.to != null) {
      setFilterObj({
        ...filterObj,
        appointmentDate: { ...filterObj.appointmentDate, to: null },
      });
    }
  }, [dateF2]);

  const intToTime = (t: number): string => {
    const hours = Math.floor(t / 60);
    const minutes = t % 60;

    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");

    return `${paddedHours}:${paddedMinutes}`;
  };
  useEffect(() => {
    if (dateSelected != null) {
      setSlotSelected(null);
      setServiceProviderAutoSelected(null);
      setVendor("");
      setVendorCode("");
      setVendorDrId(0);
      getAvailableSlots(dateSelected);
    } else {
      setSlotSelected(null);
      setServiceProviderAutoSelected(null);
      setVendor("");
      setVendorCode("");
      setVendorDrId(0);
      setSlotList([]);
    }
  }, [dateSelected]);

  useEffect(() => {
    if (aptSelectedForPayment != null && patientInfoForPayment != null) {
      setShowPaymentLinkDialog(true);
    }
  }, [aptSelectedForPayment, patientInfoForPayment]);
  const getAvailableSlots = (date: Date) => {
    setLoading2(true);
    let body = {
      planId: reschAppSelected?.planID,
      patientId: Number(reschAppSelected?.patientID),
      serviceId: reschAppSelected?.serviceID,
      serviceProviderId: selectServiceProviderCheckbox
        ? 0
        : serviceProviderSelected?.id == undefined
          ? null
          : serviceProviderSelected.id,
      bookingMode: reschAppSelected?.mode,
      collectionDate: dayjs(date).format("YYYY-MM-DD"),
      // addressId: addressSelected == null ? null : addressSelected.id,
      addressId: reschAppSelected?.addressId,
      vendor: serviceProviderSelected?.vendorId,
      vendorCode: serviceProviderSelected?.vendorCode,
      vendorDoctorId: serviceProviderSelected?.vendorDoctorId,
      providerAddressId:
        serviceProviderSelected?.address?.providerAddressId ?? null,
      memberPatientId:
        reschAppSelected?.bookedFor == 0
          ? reschAppSelected.patientID
          : (reschAppSelected?.bookedFor ?? 0),
      languageMatch: languagesSelected ?? [],
      isReschedule: true,
    };
    const onResponse = (res: any) => {
      if (res && res.slots === null) {
        showNotification({
          title: "No slots available",
          message: "",
          color: "red",
        });
      }
      setSlotList(
        res.slots == null
          ? []
          : res.slots.map((e: SlotType) => {
              return {
                label: intToTime(e.value),
                value: e,
              };
            }),
      );
      setVendor(res.vendorId);
      setVendorCode(res.vendorName);
      setVendorDrId(res?.vendorDoctorId ?? 0);
      // if (
      //   reschAppSelected?.serviceTypeID === 2 &&
      //   reschAppSelected.mode == "Home sample" &&
      //   selectServiceProviderCheckbox
      // ) {
      //   setVendor(res.vendorId);
      //   setVendorCode(res.vendorName);
      //   setVendorDrId(res?.vendorDoctorId ?? 0);
      // } else {
      //   setVendor("");
      //   setVendorCode("");
      //   setVendorDrId(0);
      // }
      if (selectServiceProviderCheckbox) {
        setServiceProviderAutoSelected(res.serviceProviderId);
      } else {
        setServiceProviderAutoSelected(null);
      }
      setLoading2(false);
    };
    const onError = (err: any) => {
      setSlotSelected(null);
      setServiceProviderAutoSelected(null);
      setVendor("");
      setVendorCode("");
      setVendorDrId(0);
      setSlotList([]);
      showNotification({
        title: "Error in fetching slots:",
        message: err?.message,
        color: "red",
      });
      setLoading2(false);
    };
    navigoDashboardUtils.getAvailableSlots(body, onResponse, onError);
  };
  const getServiceProvider = ({
    state = "",
    city = "",
    locality = "",
    languages = [],
  }: {
    state?: string;
    city?: string;
    locality?: string;
    languages?: string[];
  }) => {
    setLoading2(true);
    const body: any = {
      pageNum: 0,
      pageSize: 0,
      planId: reschAppSelected?.planID,
      serviceId: reschAppSelected?.serviceID,
      serviceMode: reschAppSelected?.mode,
      patientId: Number(reschAppSelected?.patientID),
      languageMatch: languages,
      vendorCode: reschAppSelected?.vendorCode,
      vendorDoctorId: reschAppSelected?.vendorDoctorId,
      vendorId: reschAppSelected?.vendorId,
      providerAddressId: reschAppSelected?.providerAddressId ?? null,
    };

    // Add locationFilter only if state is provided
    if (state !== "") {
      if (locality !== "") {
        body.locationFilter = [
          { stateMatch: state, cityMatch: city, landmarkMatch: locality },
        ];
      } else if (city !== "") {
        body.locationFilter = [{ stateMatch: state, cityMatch: city }];
      } else {
        body.locationFilter = [{ stateMatch: state }];
      }
    }
    if (
      reschAppSelected?.serviceProviderGroupVendorName != APOLLO_VENDOR_CODE
    ) {
      body.excludedVendors = [APOLLO_VENDOR_CODE];
    }
    const onResponse = (res: any) => {
      setServiceProviderListToShow(
        res == null || res.providers == null || res.providers.length == 0
          ? []
          : res.providers.map((e: ServiceProviderType) => {
              return {
                label: `(${e.id}) ${e.name}${
                  reschAppSelected?.serviceTypeID === 2 ||
                  reschAppSelected?.serviceTypeID === 3
                    ? ` -${e?.address?.city} -${e?.address?.landmark}`
                    : ""
                }`,
                value: {
                  id: e.id,
                  name: e.name,
                  maxBookingDays: e.maxBookingDays,
                  minBookingDays: e.minBookingDays,
                  margin: e.margin,
                  address: e.address,
                },
              };
            }),
      );
      if (res != null && res.providers != null && res.providers.length != 0) {
        let sp: ServiceProviderType = res.providers.find(
          (e: ServiceProviderType) =>
            e.id === reschAppSelected?.serviceProviderID,
        );
        if (sp) {
          setServiceProviderSelected(sp);
        }
      }
      setLoading2(false);
    };
    const onError = (err: any) => {
      setServiceProviderListToShow([]);
      showNotification({
        title: "Error in fetching service provider:",
        message: err?.message,
        color: "red",
      });
      setLoading2(false);
    };
    navigoDashboardUtils.getServiceProvider(body, onResponse, onError);
  };

  function isCentreVisitNotApollo(appointment: AppointmentType): boolean {
    return (
      appointment?.mode === "Centre visit" &&
      appointment?.serviceProviderGroupVendorName !== APOLLO_VENDOR_CODE
    );
  }

  const getSPLocation = ({
    state = null,
    city = null,
    locality = null,
    type1 = "",
  }: {
    state: string | null;
    city: string | null;
    locality: string | null;
    type1?: string;
  }) => {
    setLoading2(true);
    let body = {
      type: type1,
      state: state,
      city: city,
      locality: locality,
      planId: reschAppSelected?.planID,
      serviceId: reschAppSelected?.serviceID,
      serviceMode: reschAppSelected?.mode,
    };

    const onResponse = (res: any) => {
      if (type1 === "state") {
        setStatesLocs(
          res === null || res.state === null || res.state.length === 0
            ? []
            : res.state.map((e: any) => {
                return {
                  label: e,
                  value: e,
                };
              }),
        );
        setLoading2(false);
      } else if (type1 === "city") {
        setCityLocs(
          res === null || res.city === null || res.city.length === 0
            ? []
            : res.city.map((e: any) => {
                return {
                  label: e,
                  value: e,
                };
              }),
        );
        setLoading2(false);
      } else if (type1 === "locality") {
        setLocalityLocs(
          res === null || res.locality === null || res.locality.length === 0
            ? []
            : res.locality.map((e: any) => {
                return {
                  label: e,
                  value: e,
                };
              }),
        );
        getServiceProvider({ state: stateSelected!, city: citySelected! });
      }
    };
    const onError = (err: any) => {
      if (type1 === "state") {
        setStateSelected(null);
        setStatesLocs([]);
        setCitySelected(null);
        setCityLocs([]);
        setLocalitySelected(null);
        setLocalityLocs([]);
      } else if (type1 === "city") {
        setCitySelected(null);
        setCityLocs([]);
        setLocalitySelected(null);
        setLocalityLocs([]);
      } else if (type1 === "locality") {
        setLocalitySelected(null);
        setLocalityLocs([]);
      }
      showNotification({
        title: "Error in fetching service provider location:",
        message: err?.message,
        color: "red",
      });
      setLoading2(false);
    };
    navigoDashboardUtils.locationFilter(body, onResponse, onError);
  };

  const getHomeSampleDates = () => {
    const onResponse = (res: any) => {
      if (res != null) {
        setHomeSampleDateMin(res.minBookingDays);
        setHomeSampleDateMax(res.maxAdvBookingDays);
      }
    };
    const onError = (err: any) => {
      setHomeSampleDateMin(null);
      setHomeSampleDateMax(null);
      showNotification({
        title: "Error in fetching dates:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getHomeSampleDates(
      Number(reschAppSelected?.patientID),
      reschAppSelected?.planID!,
      onResponse,
      onError,
    );
  };
  const fetchLanguages = () => {
    setLoading2(true);
    let body = {
      planId: reschAppSelected?.planID,
      serviceId: reschAppSelected?.serviceID,
      serviceMode: reschAppSelected?.mode,
    };
    const onResponse = (res: any) => {
      setLanguagesList(
        res === null || res.languages === null || res.languages.length === 0
          ? []
          : res.languages,
      );
      getServiceProvider({});
    };
    const onError = (err: any) => {
      setLanguagesSelected([]);
      setLanguagesList([]);
      showNotification({
        title: "Error in fetching languages:",
        message: err?.message,
        color: "red",
      });
      setLoading2(false);
    };
    navigoDashboardUtils.getLanguages(body, onResponse, onError);
  };
  useEffect(() => {
    if (languagesSelected.length > 0) {
      setSelectServiceProviderCheckbox(false);
      setServiceProviderSelected(null);
      getServiceProvider({ languages: languagesSelected });
    } else {
      if (reschAppSelected?.mode != null) {
        getServiceProvider({});
      }
      setSelectServiceProviderCheckbox(false);
      setServiceProviderSelected(null);
      setServiceProviderListToShow([]);
    }
  }, [languagesSelected]);

  useEffect(() => {
    setServiceProviderSelected(null);
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
    setCityLocs([]);
    setCitySelected(null);
    setLocalitySelected(null);
    setLocalityLocs([]);
    if (stateSelected != null) {
      getSPLocation({
        state: stateSelected,
        city: null,
        locality: null,
        type1: "city",
      });
    }
  }, [stateSelected]);
  useEffect(() => {
    setServiceProviderSelected(null);
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
    setLocalitySelected(null);
    setLocalityLocs([]);
    if (citySelected != null) {
      getSPLocation({
        state: stateSelected,
        city: citySelected,
        locality: null,
        type1: "locality",
      });
    }
  }, [citySelected]);
  useEffect(() => {
    setServiceProviderSelected(null);
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
    if (localitySelected != null) {
      getServiceProvider({
        state: stateSelected!,
        city: citySelected!,
        locality: localitySelected!,
      });
    }
  }, [localitySelected]);

  useEffect(() => {
    if (reschAppSelected != null) {
      // setServiceProviderSelected(reschAppSelected.serviceProviderID);

      if (reschAppSelected?.serviceTypeID === 1) {
        fetchLanguages();
      } else if (
        reschAppSelected?.serviceTypeID === 2 ||
        reschAppSelected?.serviceTypeID === 3
      ) {
        getServiceProvider({});
        if (
          reschAppSelected.mode === "Camp site visit" ||
          isCentreVisitNotApollo(reschAppSelected)
        ) {
          getSPLocation({
            state: null,
            city: null,
            locality: null,
            type1: "state",
          });
          setStateSelected(null);
        }

        if (reschAppSelected.mode === "Home sample") {
          if (reschAppSelected?.serviceTypeID === 3) {
            const appointObj = reschAppSelected;
            getBookingConfigByVendor(
              appointObj?.patientID,
              appointObj?.serviceID,
              appointObj?.planID,
              appointObj?.vendorId,
            );
          } else {
            getHomeSampleDates();
          }
        } else {
          setHomeSampleDateMin(null);
          setHomeSampleDateMax(null);
        }
      }
      if (reschAppSelected?.serviceSubtypeID === 3) {
        getAvailCareDates();
      } else {
        setAvailCareDateMin(null);
        setAvailCareDateMax(null);
      }
    }
  }, [reschAppSelected]);

  const getBookingConfigByVendor = (
    patientID?: number,
    serviceID?: number,
    planID?: number,
    vendorId?: string,
  ) => {
    setLoading(true);

    const onResponse = (res: any) => {
      if (res) {
        setHomeSampleDateMin(res.minBookingDays);
        setHomeSampleDateMax(res.maxAdvBookingDays);
      } else {
        setHomeSampleDateMin(null);
        setHomeSampleDateMax(null);
      }
      setLoading(false);
    };

    const onError = (err: any) => {
      setHomeSampleDateMin(null);
      setHomeSampleDateMax(null);

      showNotification({
        title: "Error in fetching booking config:",
        message: err?.message,
        color: "red",
      });

      setLoading(false);
    };

    navigoDashboardUtils.getBookingConfigByVendor(
      {
        patientID: Number(patientID),
        serviceID,
        planID,
        vendorId,
      },
      onResponse,
      onError,
    );
  };

  const getAvailCareDates = () => {
    const onResponse = (res: any) => {
      if (res != null) {
        setAvailCareDateMin(res.minBookingDays);
        setAvailCareDateMax(res.maxAdvBookingDays);
      }
    };
    const onError = (err: any) => {
      setAvailCareDateMin(null);
      setAvailCareDateMax(null);
      showNotification({
        title: "Error in fetching dates:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getAvailCareDates(
      Number(reschAppSelected?.patientID),
      reschAppSelected!.planID,
      onResponse,
      onError,
    );
  };

  const rescheduleAppointment = () => {
    if (
      serviceProviderSelected == null &&
      selectServiceProviderCheckbox === false
    ) {
      showNotification({
        title: "Please select a service provider",
        message: "",
        color: "yellow",
      });
      return;
    } else if (dateSelected == null) {
      showNotification({
        title: "Please select new date",
        message: "",
        color: "yellow",
      });
      return;
    } else if (slotSelected == null) {
      showNotification({
        title: "Please select a time slot",
        message: "",
        color: "yellow",
      });
      return;
    } else {
      setLoading(true);
      const sendDate = dayjs(dateSelected).format("YYYY-MM-DD");
      const utcMidnight = new Date(sendDate + "T00:00:00Z");
      let body = {
        appointmentID: reschAppSelected?.id,
        appointmentDate: utcMidnight,

        timeslot: slotSelected.value.value,
        timeSlotId: slotSelected.value.key,
        serviceProviderID: selectServiceProviderCheckbox
          ? serviceProviderAutoSelected
          : serviceProviderSelected?.id,
      };
      const onResponse = (res: any) => {
        showNotification({
          title: "Appointment rescheduled successfully",
          message: "",
          color: "green",
        });
        setLoading(false);
        onModalClose();
        getAppointments();
      };
      const onError = (err: any) => {
        showNotification({
          title: "Error in rescheduling the appointment",
          message: "",
          color: "red",
        });
        setLoading(false);
      };

      navigoDashboardUtils.rescheduleAppointment(body, onResponse, onError);
    }
  };

  const getModes = () => {
    let onResponse = (res: any) => {
      if (res != null) {
        const allModes = res.flatMap((mode: any) => mode.modes);

        const uniqueModes = Array.from(new Set(allModes)) as string[];

        setTotalModes(uniqueModes);
      }
    };
    let onError = (err: any) => {
      showNotification({
        title: "Error in fetching modes:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getModes(onResponse, onError);
  };

  const fetchServiceCodes = (code: string) => {
    let body = {
      pageNum: 0,
      pageSize: 0,
      name: code,
    };
    const onResponse = (res: any) => {
      setTotalServiceCodes(
        res === null || res.services === null || res.services.length === 0
          ? []
          : res.services.map((e: any) => {
              return {
                label: e.name,
                value: String(e.id),
              };
            }),
      );
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in service codes:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getServiceByFilter(body, onResponse, onError);
  };

  const fetchServiceProviders1 = (code: string) => {
    let body = {
      pageNum: 0,
      pageSize: 0,
      name: code,
    };
    const onResponse = (res: any) => {
      setTotalServiceProviders(
        res === null || res.providers === null || res.providers.length === 0
          ? []
          : res.providers.map((e: any) => {
              return {
                label:
                  e.serviceTypeId === 1
                    ? e.consultationInfo.identityDetails.name
                    : e.serviceTypeId === 2
                      ? e.checkupInfo.identityDetails.name
                      : e.serviceTypeId === 3
                        ? e.vaccineInfo.identityDetails.name
                        : "",
                value: String(e.id),
              };
            }),
      );
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in service providers:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getSPByFilter(body, onResponse, onError);
  };
  const fetchServiceProviders = (code: string) => {
    let body = {
      pageNum: 0,
      pageSize: 0,
      name: code,
    };

    const onResponse = (res: any) => {
      if (!res?.providers?.length) {
        setTotalServiceProviders([]);
        setLabelToValueMap({});
        return;
      }

      const labelMap: Record<string, string[]> = {};
      const dedupedOptions: ServiceProvidersOption[] = [];

      res.providers.forEach((e: any) => {
        let label = "";

        if (e.serviceTypeId === 1) {
          label = e.consultationInfo?.identityDetails?.name;
        } else if (e.serviceTypeId === 2) {
          label = e.checkupInfo?.identityDetails?.name;
        } else if (e.serviceTypeId === 3) {
          label = e.vaccineInfo?.identityDetails?.name;
        }

        // Skip invalid entries
        if (!label) {
          return;
        }

        const value = String(e.id);

        if (!labelMap[label]) {
          labelMap[label] = [value];
          dedupedOptions.push({ label, value: label }); // use label as value for display
        } else {
          labelMap[label].push(value);
        }
      });

      setTotalServiceProviders(dedupedOptions); // de-duplicated
      setLabelToValueMap(labelMap); // full list of real IDs for each label
    };

    const onError = (err: any) => {
      showNotification({
        title: "Error in service providers:",
        message: err?.message,
        color: "red",
      });
    };

    navigoDashboardUtils.getSPByFilter(body, onResponse, onError);
  };

  const getPatientDetails = (app: AppointmentType) => {
    let onResponse = (res: PatientType) => {
      if (res == null || res.status === 3) {
        showNotification({
          title: "Patient status is not active",
          message: "",
          color: "red",
        });
        return;
      }
      if (res != null) {
        const mapped: PatientInfo = {
          patientId: res.id,
          firstName: res.firstName,
          lastName: res.lastName,
          gender: res.gender,
          dateOfBirth: res.dateOfBirth,
          phoneNo: res.phoneno,
          email: res.email,
          profileImage: res.profileImage,
          countryCode: res.countrycode,
        };
        if (isDOBEmpty(mapped) || isEmailEmpty(mapped)) {
          setPatientInfo(mapped);
          setUpdatePatientInfoDialog(true);
        } else {
          setReschAppSelected(app);
          setOpenReschAppDialog(true);
        }
      }
    };
    let onError = (err: any) => {
      showNotification({
        title: "No patient found",
        message: err?.message,
        color: "red",
      });
    };

    navigoDashboardUtils.getPatientDetails(
      String(app.patientID),
      onResponse,
      onError,
    );
  };
  const getFamilyDetails = (app: AppointmentType) => {
    let onResponse = (res: PatientType) => {
      if (res == null || res.status === 3) {
        showNotification({
          title: "Patient status is not active",
          message: "",
          color: "red",
        });
        return;
      }
      if (res != null) {
        const mapped: PatientInfo = {
          patientId: res.id,
          firstName: res.firstName,
          lastName: res.lastName,
          gender: res.gender,
          dateOfBirth: res.dateOfBirth,
          phoneNo: res.phoneno,
          email: res.email,
          profileImage: res.profileImage,
          countryCode: res.countrycode,
        };
        if (isDOBEmpty(mapped) || isEmailEmpty(mapped)) {
          setPatientInfo(mapped);
          setUpdatePatientInfoDialog(true);
        } else {
          setReschAppSelected(app);
          setOpenReschAppDialog(true);
        }
      }
    };
    let onError = (err: any) => {
      showNotification({
        title: "No patient found",
        message: err?.message,
        color: "red",
      });
    };

    navigoDashboardUtils.getPatientDetails(
      String(app.bookedFor),
      onResponse,
      onError,
    );
  };
  const getPatientDetailsForPayment = (app: AppointmentType) => {
    let onResponse = (res: PatientType) => {
      if (res == null || res.status === 3) {
        showNotification({
          title: "Patient status is not active",
          message: "",
          color: "red",
        });
        return;
      }
      if (res != null) {
        const mapped: PatientInfoForPayment = {
          id: res.id,
          firstName: res.firstName,
          lastName: res.lastName,
          gender: res.gender,
          dateOfBirth: res.dateOfBirth,
          phoneno: res.phoneno,
          email: res.email,
          profileImage: res.profileImage,
          countrycode: res.countrycode,
        };
        setPatientInfoForPayment(mapped);
        setAptSelectedForPayment(app);
      }
    };
    let onError = (err: any) => {
      showNotification({
        title: "No patient found",
        message: err?.message,
        color: "red",
      });
    };

    navigoDashboardUtils.getPatientDetails(
      String(app.patientID),
      onResponse,
      onError,
    );
  };

  const checkPatientInfo = (app: AppointmentType) => {
    setAppSelected(app);
    if (app.bookedFor === 0) {
      getPatientDetails(app);
    } else {
      getFamilyDetails(app);
    }
  };

  const closePatientInfoDialog = () => {
    setNewDob(null);
    setNewEmail("");
    setPatientInfo(null);
    setUpdatePatientInfoDialog(false);
  };

  const isDOBEmpty = (patient: PatientInfo | null): boolean => {
    const dob = patient?.dateOfBirth;
    return (
      dob === undefined ||
      dob === null ||
      dob === "" ||
      isNaN(Number(dob)) ||
      Number(dob) === 0
    );
  };

  const isEmailEmpty = (patient: PatientInfo | null): boolean => {
    const email = patient?.email;
    return (
      email === undefined ||
      email === null ||
      typeof email !== "string" ||
      email.trim() === ""
    );
  };

  const isValidEmail = (email: string | null | undefined): boolean => {
    if (
      typeof email !== "string" ||
      email.trim() === "" ||
      !email.includes("@")
    ) {
      return false;
    }

    const [localPart, domain] = email.trim().split("@");

    if (!localPart || !domain) return false;

    const isValidEmailDomain = (domain: string): boolean =>
      /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(domain);

    return isValidEmailDomain(domain);
  };

  const updatePatientInfo = (patient: PatientInfo) => {
    if (isDOBEmpty(patient) && newDob === null) {
      showNotification({
        title: "Please fill the Date of birth",
        message: "",
        color: "yellow",
      });
      return;
    }

    if (isEmailEmpty(patient) && newEmail !== "" && !isValidEmail(newEmail)) {
      showNotification({
        title: "Please enter a valid email address",
        message: "",
        color: "yellow",
      });
      return;
    }

    const body = {
      patientId: patient.patientId,
      firstName: patient.firstName,
      lastName: patient.lastName ? patient.lastName : null,
      gender: patient.gender,
      dateOfBirth: isDOBEmpty(patient)
        ? dayjs(newDob).format("YYYY-MM-DD")
        : dayjs(patient.dateOfBirth).format("YYYY-MM-DD"),

      phoneNo: String(patient.phoneNo),
      email: newEmail !== "" ? newEmail : patient.email,
      profileImage: patient.profileImage,
      countryCode: patient.countryCode,
    };

    const onResponse = (res: any) => {
      setLoadingProfileUpdate(false);
      closePatientInfoDialog();
      showNotification({
        title:
          "Profile information updated successfully, try rescheduling again",
        message: "",
        color: "green",
      });
      setReschAppSelected(appSelected);
      setOpenReschAppDialog(true);
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in updating profile:",
        message: err?.message,
        color: "red",
      });
      setLoadingProfileUpdate(false);
    };

    if (!isDOBEmpty(patient) && newEmail === "") {
      onResponse("");
    } else {
      setLoadingProfileUpdate(true);
      navigoDashboardUtils.updateProfileInfo(body, onResponse, onError);
    }
  };

  type PatientType = {
    id: number;
    status: number;
    phoneno: number;
    firstName: string;
    lastName: string;
    countrycode: number;
    gender: number;
    dateOfBirth: number;
    email: string;
    profileImage: string;
  };
  type AppointmentType = {
    id: number;
    patientID: number;
    bookedFor: number;
    addressId: number;
    accountCode: string;
    planID: number;
    serviceTypeName: string;
    serviceTypeID: number;
    serviceSubtypeID: number;
    serviceSubtypeName: string;
    serviceProviderGroupVendorName: string;
    serviceID: number;
    serviceName: string;
    serviceCode: string;
    mode: string;
    serviceProviderID: number;
    serviceProviderName: string;
    status: number;
    bookingDate: Date;
    appointmentDate: Date;
    timeSlot: number;
    timeSlotId: number;
    isCustomContactNumber: boolean;
    customContactNumber: CustomContactNumberType;
    reportURL: string;
    email: string;
    selectedZone: number;
    calendarEventID: string;
    paymentOrderId: string;
    paymentStatusResponse: number;
    vendorCode: string;
    vendorId: string;
    vendorDoctorId: number;
    externalOrderId: string;
    reasonId: number;
    reasonDetails: string;
    blockRescheduling: boolean;
    tenantId: number;
    createdBy: number;
    createdAt: Date;
    updatedAt: Date;
    providerAddressId?: string;
  };

  type CustomContactNumberType = {
    countryCode: number;
    phoneNo: number;
  };
  type AppResponseType = {
    appointments: AppointmentType[];
    totalCount: number;
    resultCount: number;
  };
  type ServiceProviderType = {
    address: any;
    // amenities: any;
    // availability: any;
    // desktopCover: string;
    // experience: string;
    id: number;
    // languages: any;
    // licenseNumber: string;
    // longDescription: string;
    maxBookingDays: number;
    minBookingDays: number;
    // mobileCover: string;
    name: string;
    // shortdescription: string;
    margin?: {
      colour?: string;
    };
    vendorId: string;
    vendorCode: string;
    vendorDoctorId: number;
  };
  type ServiceProviderOption = {
    label: string;
    value: ServiceProviderType;
  };
  type SlotOption = {
    label: string;
    value: SlotType;
  };
  type SlotType = {
    key: number;
    value: number;
  };
  type ServiceCodeOption = {
    label: string;
    value: string;
  };
  type PayStatusOption = {
    label: string;
    value: string;
  };
  type ServiceProvidersOption = {
    label: string;
    value: string;
  };
  type LocOption = {
    label: string;
    value: string;
  };
  type PatientInfo = {
    patientId: number;
    firstName: string;
    lastName: string;
    gender: number;
    dateOfBirth: string | number;
    phoneNo: string | number;
    email: string;
    profileImage: string;
    countryCode: number;
  };
  type PatientInfoForPayment = {
    id: number;
    firstName: string;
    lastName: string;
    gender: number;
    dateOfBirth: string | number;
    phoneno: string | number;
    email: string;
    profileImage: string;
    countrycode: number;
  };
  function isAutoSPAllowed(mode: string) {
    return MODES_WITH_AUTO_SP.includes(mode);
  }

  const isDatePickerDisabled = (): boolean => {
    if (loading2) return true;

    const isAvailCare = reschAppSelected?.serviceSubtypeID === 3;
    const isHomeSample = reschAppSelected?.mode === "Home sample";
    const isNotHomeSample = !isHomeSample;

    // Avail care checks
    if (isAvailCare) {
      if (availCareDateMin === null || availCareDateMax === null) return true;
      if (areDatesAvailable() === false) return true;
    }
    // Home sample checks
    if (isHomeSample) {
      if (homeSampleDateMin === null || homeSampleDateMax === null) return true;
      if (areDatesAvailable() === false) return true;
    }

    // Non-home sample checks
    if (isNotHomeSample) {
      if (serviceProviderSelected && areDatesAvailable() === false) return true;

      if (
        selectServiceProviderCheckbox === false &&
        (serviceProviderSelected?.minBookingDays == null ||
          serviceProviderSelected?.maxBookingDays == null)
      ) {
        return true;
      }
    }

    return false;
  };

  const areDatesAvailable = (): boolean => {
    const isAvailCare = reschAppSelected?.serviceSubtypeID === 3;
    const isHomeSample = reschAppSelected?.mode === "Home sample";

    if (isAvailCare) {
      const noDates = availCareDateMin === availCareDateMax;
      if (noDates) {
        showNotification({
          title: "No date available",
          message: "",
          color: "red",
        });
        return false;
      }
      return true;
    }

    if (isHomeSample) {
      const noDates = homeSampleDateMin === homeSampleDateMax;
      if (noDates) {
        showNotification({
          title: "No date available",
          message: "",
          color: "red",
        });
        return false;
      }
      return true;
    }

    if (selectServiceProviderCheckbox) return true;

    const minDays = serviceProviderSelected?.minBookingDays ?? 0;
    const maxDays = serviceProviderSelected?.maxBookingDays ?? 1;

    const noDates = minDays === maxDays;
    if (noDates) {
      showNotification({
        title: "No date available",
        message: "",
        color: "red",
      });
      return false;
    }
    return true;
  };

  const getMinDate = (): Date => {
    const baseDate = dayjs().utc().startOf("day");
    const isAvailCare = reschAppSelected?.serviceSubtypeID === 3;
    const isHomeSample = reschAppSelected?.mode === "Home sample";

    if (isAvailCare) {
      return baseDate.add(availCareDateMin ?? 0, "day").toDate();
    }
    if (isHomeSample) {
      return baseDate.add(homeSampleDateMin ?? 0, "day").toDate();
    }

    if (selectServiceProviderCheckbox) {
      return baseDate.toDate();
    }

    const minDays = serviceProviderSelected?.minBookingDays ?? 0;
    return baseDate.add(minDays, "day").toDate();
  };

  const getMaxDate = (): Date | undefined => {
    const baseDate = dayjs().utc().startOf("day");
    const isAvailCare = reschAppSelected?.serviceSubtypeID === 3;
    const isHomeSample = reschAppSelected?.mode === "Home sample";

    if (isAvailCare) {
      return baseDate.add((availCareDateMax ?? 1) - 1, "day").toDate();
    }

    if (isHomeSample) {
      return baseDate.add((homeSampleDateMax ?? 1) - 1, "day").toDate();
    }

    if (selectServiceProviderCheckbox) return undefined;

    const maxDays = serviceProviderSelected?.maxBookingDays ?? 1;
    return baseDate.add(maxDays - 1, "day").toDate();
  };

  const onModalClose = () => {
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
    setServiceProviderSelected(null);
    setDateSelected(null);
    setSlotList([]);
    setSlotSelected(null);
    setHomeSampleDateMin(null);
    setHomeSampleDateMax(null);
    setReschAppSelected(null);
    setLanguagesList([]);
    setLanguagesSelected([]);
    setStatesLocs([]);
    setStateSelected(null);
    setCityLocs([]);
    setCitySelected(null);
    setLocalityLocs([]);
    setLocalitySelected(null);
    setAppSelected(null);
    setOpenReschAppDialog(false);
  };

  return (
    <div className="view-appointment-container">
      <div className="va-heading">
        <Button
          onClick={() => {
            navigate("/");
          }}
        >
          <IconArrowLeft width={36} height={36} color="#ef7c01"></IconArrowLeft>
        </Button>
        <div className="text">Past appointments</div>
      </div>

      <br />
      <div className="row-left-margin">
        <Row>
          <Col xs={12} sm={4} md={2} lg={2}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                Patient ID
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <TextInput
                  placeholder=""
                  value={pid === null ? "" : pid}
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={4} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                Appointment ID
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <TextInput
                  placeholder="Search via appointment ID"
                  value={appIdSearch}
                  disabled={loading}
                  onChange={(e) => {
                    const input = e.currentTarget.value;
                    if (appIdSearch != "" && input === "") {
                      let newFilterObj = filterObj;
                      delete newFilterObj.appointmentId;
                      setFilterObj({
                        ...newFilterObj,
                        pageNum: 1,
                      });
                      setPageNum(1);
                    }
                    const digitsOnly = input.replace(/\D/g, "").slice(0, 10);
                    setAppIdSearch(digitsOnly);
                  }}
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <Button
              style={
                appIdSearch === ""
                  ? {
                      marginTop: "23px",
                      width: "100px",
                      height: "38px",
                      marginBottom: "50px",
                      color: "#ffffff",
                      backgroundColor: "#C2C2C2",
                    }
                  : {
                      marginTop: "23px",
                      width: "100px",
                      height: "38px",
                      marginBottom: "50px",
                      color: "#ffffff",
                      backgroundColor: "#ef7c01",
                    }
              }
              disabled={appIdSearch === "" || loading}
              onClick={() => {
                setFilterObj({
                  ...filterObj,
                  pageNum: 1,
                  appointmentId: Number(appIdSearch),
                });
                setPageNum(1);
              }}
            >
              Search
            </Button>
          </Col>
        </Row>
      </div>
      <div className="row-left-margin">
        <div className="appointments-table-container">
          <div className="table">
            {/* Header */}
            <div className="table-row-1 table-header">
              <div className="table-cell" style={{ width: "10%" }}>
                <div>{`Appointment`}</div>
                <div>{`ID`}</div>
              </div>
              <div className="table-cell" style={{ width: "15%" }}>
                <div style={{ display: "flex" }}>
                  <div>
                    <div>{`Appointment`}</div>
                    <div>{`date`}</div>
                  </div>

                  <Popover
                    width={272}
                    position="bottom"
                    withArrow
                    shadow="md"
                    opened={dateFilterOpened}
                    onChange={setDateFilterOpened}
                  >
                    {loading === false && (
                      <Popover.Target>
                        <div
                          style={{ marginLeft: "10px", cursor: "pointer" }}
                          onClick={() => {
                            setDateFilterOpened(true);
                          }}
                        >
                          <img
                            src={
                              filterObj?.appointmentDate?.from != null ||
                              filterObj?.appointmentDate?.to != null
                                ? filter2
                                : filter1
                            }
                            alt="filter"
                            style={{ height: "12px" }}
                          />
                        </div>
                      </Popover.Target>
                    )}

                    <Popover.Dropdown>
                      <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "20px", marginTop: "8px" }}>
                          From
                        </div>
                        <div>
                          <DatePicker
                            weekendDays={[]}
                            dropdownPosition="bottom-start"
                            placeholder="Choose a date"
                            disabled={loading}
                            clearable
                            value={dateF1}
                            onChange={(val) => {
                              setDateF1(val ? val : null);
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ display: "flex", marginTop: "7px" }}>
                        <div style={{ marginRight: "38px", marginTop: "8px" }}>
                          To
                        </div>
                        <div>
                          <DatePicker
                            weekendDays={[]}
                            dropdownPosition="bottom-start"
                            placeholder="Choose a date"
                            disabled={loading}
                            clearable
                            value={dateF2}
                            onChange={(val) => {
                              setDateF2(val ? val : null);
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div>
                          <Button
                            disabled={loading}
                            style={{
                              marginTop: "10px",
                              width: "100px",
                              height: "28px",
                              color: "#ffffff",
                              backgroundColor: "#ef7c01",
                            }}
                            onClick={() => {
                              if (
                                dateF1 &&
                                dateF2 &&
                                dayjs(dateF1).isAfter(dateF2)
                              ) {
                                showNotification({
                                  title:
                                    "From date cannot be after To end date",
                                  message: "",
                                  color: "red",
                                });
                              } else {
                                setFilterObj({
                                  ...filterObj,
                                  appointmentDate: {
                                    from: dayjs(dateF1)
                                      .startOf("day")
                                      .utc()
                                      .toDate(),
                                    to: dayjs(dateF2)
                                      .endOf("day")
                                      .utc()
                                      .toDate(),
                                  },
                                });
                                setDateFilterOpened(false);
                              }
                            }}
                          >
                            Search
                          </Button>
                        </div>
                        <div style={{ marginLeft: "32px" }}>
                          <Button
                            disabled={loading}
                            style={{
                              marginTop: "10px",
                              width: "100px",
                              height: "28px",
                              color: "#ffffff",
                              backgroundColor: "#c2c2c2",
                            }}
                            onClick={() => {
                              setDateF1(null);
                              setDateF2(null);
                              // let newFilterObj = filterObj;
                              // delete newFilterObj.appointmentDate;
                              // setFilterObj(newFilterObj);
                              setFilterObj({
                                ...filterObj,
                                appointmentDate: {
                                  from: null,
                                  to: null,
                                },
                              });
                              setDateFilterOpened(false);
                            }}
                          >
                            Clear
                          </Button>
                        </div>
                      </div>
                    </Popover.Dropdown>
                  </Popover>
                </div>
              </div>
              <div className="table-cell" style={{ width: "10%" }}>
                <div>{`Time slot`}</div>
              </div>
              <div className="table-cell" style={{ width: "10%" }}>
                <div style={{ display: "flex" }}>
                  <div>
                    <div>{`Service`}</div>
                    <div>{`code`}</div>
                  </div>
                  <Popover width={300} position="bottom" withArrow shadow="md">
                    {loading === false && (
                      <Popover.Target>
                        <div style={{ marginLeft: "10px", cursor: "pointer" }}>
                          <img
                            src={
                              filteredServiceCodes.length === 0
                                ? filter1
                                : filter2
                            }
                            alt="filter"
                            style={{ height: "12px" }}
                          />
                        </div>
                      </Popover.Target>
                    )}

                    <Popover.Dropdown>
                      <MultiSelect
                        label="Select codes"
                        placeholder="Type here"
                        searchable
                        clearable
                        data={totalServiceCodes}
                        value={filteredServiceCodes}
                        searchValue={searchedServiceCode}
                        onSearchChange={setSearchedServiceCode}
                        onChange={setFilteredServiceCodes}
                      />
                    </Popover.Dropdown>
                  </Popover>
                </div>
              </div>
              <div className="table-cell" style={{ width: "10%" }}>
                <div style={{ display: "flex" }}>
                  <div>
                    <div>{`Service`}</div>
                    <div>{`mode`}</div>
                  </div>
                  <Popover width={300} position="bottom" withArrow shadow="md">
                    {loading === false && (
                      <Popover.Target>
                        <div style={{ marginLeft: "10px", cursor: "pointer" }}>
                          <img
                            src={filteredModes.length === 0 ? filter1 : filter2}
                            alt="filter"
                            style={{ height: "12px" }}
                          />
                        </div>
                      </Popover.Target>
                    )}

                    <Popover.Dropdown>
                      <MultiSelect
                        label="Select modes"
                        placeholder="Type here"
                        searchable
                        clearable
                        data={totalModes}
                        value={filteredModes}
                        onChange={(values) => {
                          setFilteredModes(values);
                        }}
                      />
                    </Popover.Dropdown>
                  </Popover>
                </div>
              </div>
              <div className="table-cell" style={{ width: "20%" }}>
                <div style={{ display: "flex" }}>
                  <div>
                    <div>{`Service provider`}</div>
                    <div>{`name`}</div>
                  </div>
                  <Popover width={300} position="bottom" withArrow shadow="md">
                    {loading === false && (
                      <Popover.Target>
                        <div style={{ marginLeft: "10px", cursor: "pointer" }}>
                          <img
                            src={
                              filteredServiceProviders.length === 0
                                ? filter1
                                : filter2
                            }
                            alt="filter"
                            style={{ height: "12px" }}
                          />
                        </div>
                      </Popover.Target>
                    )}

                    <Popover.Dropdown>
                      <MultiSelect
                        label="Select provider"
                        placeholder="Type here"
                        searchable
                        clearable
                        data={totalServiceProviders}
                        value={filteredServiceProviders}
                        searchValue={searchedServiceProvider}
                        onSearchChange={setSearchedServiceProvider}
                        onChange={setFilteredServiceProviders}
                      />
                    </Popover.Dropdown>
                  </Popover>
                </div>
              </div>
              <div className="table-cell" style={{ width: "10%" }}>
                <div style={{ display: "flex" }}>
                  <div>
                    <div>{`Pay`}</div>
                    <div>{`status`}</div>
                  </div>
                  <Popover width={300} position="bottom" withArrow shadow="md">
                    {loading === false && (
                      <Popover.Target>
                        <div style={{ marginLeft: "10px", cursor: "pointer" }}>
                          <img
                            src={
                              filteredPayStatus.length === 0 ? filter1 : filter2
                            }
                            alt="filter"
                            style={{ height: "12px" }}
                          />
                        </div>
                      </Popover.Target>
                    )}

                    <Popover.Dropdown>
                      <MultiSelect
                        label="Select status"
                        placeholder="Type here"
                        searchable
                        clearable
                        data={totalPayStatus.filter(
                          (item) =>
                            item.value !==
                            String(APPOINTMENT_PAYMENT_STATUS.REFUNDED),
                        )}
                        value={filteredPayStatus}
                        searchValue={searchedPayStatus}
                        onSearchChange={setSearchedPayStatus}
                        onChange={setFilteredPayStatus}
                      />
                    </Popover.Dropdown>
                  </Popover>
                </div>
              </div>
              <div
                className="table-cell"
                style={{ width: "10%", textAlign: "center" }}
              >
                <div>{`Status`}</div>
              </div>
              <div className="table-cell" style={{ width: "5%" }}>
                <div>{``}</div>
              </div>
            </div>

            {/* Rows */}
            {loading && (
              <div
                style={{
                  display: "flex",
                  marginTop: "100px",
                  marginBottom: "100px",
                  justifyContent: "center",
                }}
              >
                <Loader color="orange" />
              </div>
            )}
            {isAppLoaded && appointments.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  fontWeight: "bold",
                  color: "red",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                No appointment found!
              </div>
            ) : (
              <>
                <div className="table-pagination-row">
                  {appointments.length === 0 || loading ? (
                    <></>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={
                          pageNum === 1
                            ? {
                                display: "flex",
                                alignItems: "center",
                              }
                            : {
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                              }
                        }
                        onClick={() => {
                          if (pageNum > 1) {
                            setOnlyPagePrev(true);
                          }
                        }}
                      >
                        <IconChevronLeft
                          width={20}
                          height={20}
                          color={pageNum === 1 ? "#c2c2c2" : "#ef7c01"}
                        ></IconChevronLeft>
                      </div>
                      <div>&nbsp;{`Showing`}&nbsp;</div>
                      <div style={{ color: "#ef7c01" }}>{`${
                        (pageNum - 1) * pageSize + 1
                      }-${(pageNum - 1) * pageSize + resultCount}`}</div>
                      <div>&nbsp;{`of ${totalCount}`}&nbsp;</div>
                      <div
                        style={
                          !((pageNum - 1) * pageSize + resultCount < totalCount)
                            ? {
                                display: "flex",
                                alignItems: "center",
                              }
                            : {
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                              }
                        }
                        onClick={() => {
                          if (
                            (pageNum - 1) * pageSize + resultCount <
                            totalCount
                          ) {
                            setOnlyPageNext(true);
                          }
                        }}
                      >
                        <IconChevronRight
                          width={20}
                          height={20}
                          color={
                            !(
                              (pageNum - 1) * pageSize + resultCount <
                              totalCount
                            )
                              ? "#c2c2c2"
                              : "#ef7c01"
                          }
                        ></IconChevronRight>
                      </div>
                    </div>
                  )}
                </div>
                <div className="table-row-container">
                  {appointments.length === 0 || loading ? (
                    <></>
                  ) : (
                    appointments.map((app: AppointmentType) => {
                      return (
                        <div className="table-row">
                          <div className="table-cell" style={{ width: "10%" }}>
                            {app.id}
                          </div>
                          <div className="table-cell" style={{ width: "15%" }}>
                            {dayjs(app.appointmentDate).format("DD MMM YYYY")}
                          </div>
                          <div className="table-cell" style={{ width: "10%" }}>
                            {intToTime(app.timeSlot)}
                          </div>
                          <div className="table-cell" style={{ width: "10%" }}>
                            {app.serviceCode}
                          </div>
                          <div className="table-cell" style={{ width: "10%" }}>
                            {app.mode}
                          </div>
                          <div className="table-cell" style={{ width: "20%" }}>
                            {app.serviceProviderName}
                          </div>
                          <div className="table-cell" style={{ width: "10%" }}>
                            {app?.paymentStatusResponse != null && (
                              <Tooltip
                                title={
                                  getAppointmentPaymentStatusList().find(
                                    (s) => s.id === app.paymentStatusResponse,
                                  )?.label ||
                                  (app.paymentStatusResponse ===
                                  APPOINTMENT_PAYMENT_STATUS.LINK_EXPIRED
                                    ? "Link expired"
                                    : app.paymentStatusResponse ===
                                        APPOINTMENT_PAYMENT_STATUS.LINK_CANCELLED
                                      ? "Link cancelled"
                                      : "")
                                }
                                enterDelay={0}
                                enterNextDelay={0}
                              >
                                <span
                                  onClick={() => {
                                    if (
                                      app.paymentStatusResponse ===
                                        APPOINTMENT_PAYMENT_STATUS.PENDING ||
                                      app.paymentStatusResponse ===
                                        APPOINTMENT_PAYMENT_STATUS.INITIATED
                                    ) {
                                      getPatientDetailsForPayment(app);
                                    }
                                  }}
                                  style={{
                                    cursor:
                                      app.paymentStatusResponse ===
                                      APPOINTMENT_PAYMENT_STATUS.PENDING
                                        ? "pointer"
                                        : "default",
                                    display: "inline-block",
                                  }}
                                >
                                  <img
                                    src={
                                      app.paymentStatusResponse ===
                                      APPOINTMENT_PAYMENT_STATUS.PENDING
                                        ? paymentStatusPendingIcon
                                        : app.paymentStatusResponse ===
                                            APPOINTMENT_PAYMENT_STATUS.COMPLETE
                                          ? paymentStatusPaidIcon
                                          : app.paymentStatusResponse ===
                                              APPOINTMENT_PAYMENT_STATUS.INITIATED
                                            ? paymentStatusRequestedIcon
                                            : app.paymentStatusResponse ===
                                                  APPOINTMENT_PAYMENT_STATUS.FAILED ||
                                                app.paymentStatusResponse ===
                                                  APPOINTMENT_PAYMENT_STATUS.LINK_EXPIRED ||
                                                app.paymentStatusResponse ===
                                                  APPOINTMENT_PAYMENT_STATUS.LINK_CANCELLED
                                              ? paymentStatusFailedIcon
                                              : app.paymentStatusResponse ===
                                                  APPOINTMENT_PAYMENT_STATUS.SPONSORED
                                                ? paymentStatusSponsoredIcon
                                                : app.paymentStatusResponse ===
                                                    APPOINTMENT_PAYMENT_STATUS.REFUNDED
                                                  ? paymentStatusRefundedIcon
                                                  : undefined
                                    }
                                    alt="payment-status"
                                  />
                                </span>
                              </Tooltip>
                            )}
                          </div>
                          <div
                            className="table-cell"
                            style={{ width: "10%", padding: "4px 0px 4px 0px" }}
                          >
                            {app.status != null ? (
                              <div
                                style={{
                                  backgroundColor: `${
                                    getStatusColor(app.status).background
                                  }`,
                                  padding: "4px",
                                  borderRadius: "10px",
                                  textAlign: "center",
                                }}
                              >
                                {getStatusName(app.status)}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="table-icon" style={{ width: "5%" }}>
                            {app?.blockRescheduling ? (
                              <></>
                            ) : (
                              <>
                                {" "}
                                <div
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    checkPatientInfo(app);
                                  }}
                                >
                                  {
                                    <IconEdit
                                      width={25}
                                      height={25}
                                      color="#ef7c01"
                                    ></IconEdit>
                                  }
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <br />
      <Modal
        size={
          (reschAppSelected?.serviceTypeID === 2 ||
            reschAppSelected?.serviceTypeID === 3) &&
          (reschAppSelected.mode === "Camp site visit" ||
            isCentreVisitNotApollo(reschAppSelected))
            ? "70%"
            : "50%"
        }
        centered
        style={{ position: "fixed" }}
        opened={openReschAppDialog}
        title={
          <div style={{ fontSize: "28px", fontWeight: "500" }}>
            {`Reschedule appointment (${reschAppSelected?.id})`}
          </div>
        }
        onClose={() => {
          onModalClose();
        }}
      >
        <div>
          {reschAppSelected?.serviceTypeID === 1 &&
            reschAppSelected?.mode != "In person consultation" && (
              <>
                <Row>
                  <Col xs={12} sm={5} md={5} lg={5}>
                    <div className="navigo-module-create-service-field-container">
                      <div
                        className="navigo-module-label"
                        style={{ marginBottom: "5px" }}
                      >
                        Language
                      </div>
                      <div className="small-dropdown">
                        <MultiSelect
                          placeholder="Type here"
                          searchable
                          // disabled={loading2}
                          readOnly={loading2}
                          clearable
                          data={languagesList}
                          value={languagesSelected}
                          onChange={(values) => {
                            setLanguagesSelected(values);
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <br />
              </>
            )}
          {(reschAppSelected?.serviceTypeID === 2 ||
            reschAppSelected?.serviceTypeID === 3) &&
            (reschAppSelected.mode === "Camp site visit" ||
              isCentreVisitNotApollo(reschAppSelected)) && (
              <>
                <div>
                  <Row>
                    <Col xs={12} sm={3} md={3} lg={3}>
                      <div className="navigo-module-create-service-field-container">
                        <div
                          className="navigo-module-label"
                          style={{ marginBottom: "5px" }}
                        >
                          Select state
                          {stateSelected != null && (
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          )}
                        </div>
                        <div className="small-dropdown">
                          <SearchDropdown
                            options={statesLocs}
                            isDisabled={
                              reschAppSelected.mode === null || loading
                            }
                            value={
                              statesLocs.find(
                                (opt) => opt.value === stateSelected,
                              ) || null
                            }
                            blurInputOnSelect
                            placeholder="Select"
                            onChange={(val: LocOption | null) => {
                              setStateSelected(val?.value || null);
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={1} md={1} lg={1}>
                      <div style={{ height: "20px" }}></div>
                    </Col>
                    <Col xs={12} sm={3} md={3} lg={3}>
                      <div className="navigo-module-create-service-field-container">
                        <div
                          className="navigo-module-label"
                          style={{ marginBottom: "5px" }}
                        >
                          Select city
                          {stateSelected != null && (
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          )}
                        </div>
                        <div className="small-dropdown">
                          <SearchDropdown
                            options={cityLocs}
                            isDisabled={stateSelected === null || loading}
                            value={
                              cityLocs.find(
                                (opt) => opt.value === citySelected,
                              ) || null
                            }
                            blurInputOnSelect
                            placeholder="Select"
                            onChange={(val: LocOption | null) => {
                              setCitySelected(val?.value || null);
                            }}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col xs={12} sm={1} md={1} lg={1}>
                      <div style={{ height: "20px" }}></div>
                    </Col>
                    <Col xs={12} sm={3} md={3} lg={3}>
                      <div className="navigo-module-create-service-field-container">
                        <div
                          className="navigo-module-label"
                          style={{ marginBottom: "5px" }}
                        >
                          Select locality
                          {/* <label className="navigo-module-label-red"> *</label> */}
                        </div>
                        <div className="small-dropdown">
                          <SearchDropdown
                            options={localityLocs}
                            isDisabled={citySelected === null || loading}
                            value={
                              localityLocs.find(
                                (opt) => opt.value === localitySelected,
                              ) || null
                            }
                            blurInputOnSelect
                            placeholder="Select"
                            onChange={(val: LocOption | null) => {
                              setLocalitySelected(val?.value || null);
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                <br />
              </>
            )}
          {reschAppSelected &&
          (reschAppSelected?.mode === "Home sample" ||
            reschAppSelected?.mode === "In person consultation" ||
            (reschAppSelected?.mode === "Centre visit" &&
              reschAppSelected?.serviceProviderGroupVendorName ===
                APOLLO_VENDOR_CODE)) ? (
            <></>
          ) : (
            <>
              {" "}
              <Row>
                <Col xs={12} sm={8} md={8} lg={8}>
                  <div className="navigo-module-create-service-field-container">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "0px",
                      }}
                    >
                      <div>
                        <Checkbox
                          size="sm"
                          color="green"
                          disabled={
                            !isAutoSPAllowed(reschAppSelected?.mode ?? "") ||
                            loading2
                          }
                          checked={selectServiceProviderCheckbox}
                          onChange={(event) => {
                            setServiceProviderSelected(null);
                            setSelectServiceProviderCheckbox(
                              !selectServiceProviderCheckbox,
                            );
                          }}
                        />
                      </div>
                      <div className="navigo-module-label-overflow">
                        Select service provider or check mark to select
                        automatically
                        <label className="navigo-module-label-red"> *</label>
                      </div>
                    </div>

                    <div className="small-dropdown">
                      <SearchDropdown
                        options={serviceProviderListToShow}
                        isDisabled={selectServiceProviderCheckbox || loading2}
                        value={
                          serviceProviderListToShow.find(
                            (opt) =>
                              opt.value.id === serviceProviderSelected?.id,
                          ) || null
                        }
                        blurInputOnSelect
                        placeholder={
                          selectServiceProviderCheckbox
                            ? "Not required"
                            : "Select"
                        }
                        onChange={(val: ServiceProviderOption | null) => {
                          setServiceProviderSelected(val?.value || null);
                        }}
                        formatOptionLabel={(option) => (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {option?.value?.margin?.colour ? (
                              <span
                                style={{
                                  width: 12,
                                  height: 12,
                                  borderRadius: "50%",
                                  backgroundColor: option.value.margin.colour,
                                  marginRight: 8,
                                }}
                              />
                            ) : null}
                            <span>{option.label}</span>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              <br />
            </>
          )}

          {serviceProviderSelected?.id && (
            <>
              <Row>
                <Col xs={12} sm={5} md={5} lg={5}>
                  <div className="navigo-module-create-service-field-container">
                    <div className="navigo-module-label-2">
                      Choose date
                      <label className="navigo-module-label-red"> *</label>
                    </div>
                    <div className="small-dropdown">
                      <DatePicker
                        weekendDays={[]}
                        dropdownPosition="bottom-start"
                        placeholder="Choose a date"
                        clearable={false}
                        value={dateSelected}
                        disabled={isDatePickerDisabled()}
                        onChange={(val) => {
                          if (val) {
                            const startOfDayUTC = dayjs(val)
                              .startOf("day")
                              .toDate();
                            setDateSelected(startOfDayUTC);
                          }
                        }}
                        minDate={getMinDate()}
                        maxDate={getMaxDate()}
                      />
                    </div>
                  </div>
                </Col>

                <Col xs={12} sm={1} md={1} lg={1}>
                  <div style={{ height: "20px" }}></div>
                </Col>

                <Col xs={12} sm={5} md={5} lg={5}>
                  <div className="navigo-module-create-service-field-container">
                    <div className="navigo-module-label-2">
                      Choose timeslot
                      <label className="navigo-module-label-red"> *</label>
                    </div>
                    <div className="small-dropdown">
                      <SearchDropdown
                        options={slotList}
                        isDisabled={dateSelected === null || loading2}
                        value={slotSelected}
                        blurInputOnSelect
                        placeholder="Select"
                        onChange={(val: SlotOption | null) => {
                          setSlotSelected(val);
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              <br />
            </>
          )}

          <Row>
            <Col xs={12} sm={10} md={7} lg={5}>
              <Button
                style={
                  loading
                    ? {
                        height: "38px",
                        marginBottom: "10px",
                        color: "#ffffff",
                        textTransform: "none",
                        backgroundColor: "#c2c2c2",
                        padding: "0px 15px",
                      }
                    : {
                        height: "38px",
                        marginBottom: "10px",
                        color: "#ffffff",
                        textTransform: "none",
                        backgroundColor: "#ef7c01",
                        padding: "0px 15px",
                      }
                }
                disabled={loading}
                onClick={() => {
                  rescheduleAppointment();
                }}
              >
                Reschedule appointment
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
      {updatePatientInfoDialog && (
        <>
          <Modal
            size={"40%"}
            centered
            style={{ position: "fixed" }}
            opened={updatePatientInfoDialog}
            title={
              <div style={{ fontSize: "28px", fontWeight: "500" }}>
                Update missing profile details
              </div>
            }
            onClose={() => {
              !loadingProfileUpdate && closePatientInfoDialog();
            }}
          >
            <div>
              <br />
              {patientInfo && (
                <>
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6}>
                      <div className="navigo-module-create-service-field-container">
                        <div
                          className="navigo-module-label"
                          style={{ marginBottom: "4px" }}
                        >
                          Patient name
                        </div>
                        <div className="small-dropdown">
                          <TextInput
                            placeholder=""
                            value={`${patientInfo.firstName} ${patientInfo.lastName}`}
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  {isDOBEmpty(patientInfo) && (
                    <>
                      <Row>
                        <Col xs={12} sm={6} md={6} lg={6}>
                          <div className="navigo-module-create-service-field-container">
                            <div
                              className="navigo-module-label"
                              style={{ marginBottom: "4px" }}
                            >
                              Date of birth
                              <label className="navigo-module-label-red">
                                *
                              </label>
                            </div>
                            <div className="small-dropdown">
                              <DatePicker
                                weekendDays={[]}
                                dropdownPosition="bottom-start"
                                placeholder="Choose a date"
                                clearable={false}
                                value={newDob}
                                onChange={(val) => {
                                  if (val) {
                                    const startOfDayUTC = dayjs(val).toDate();
                                    setNewDob(startOfDayUTC);
                                  }
                                }}
                                minDate={dayjs().subtract(100, "year").toDate()}
                                maxDate={dayjs().utc().startOf("day").toDate()}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                    </>
                  )}
                  {isEmailEmpty(patientInfo) && (
                    <>
                      <Row>
                        <Col xs={12} sm={6} md={6} lg={6}>
                          <div className="navigo-module-create-service-field-container">
                            <div
                              className="navigo-module-label"
                              style={{ marginBottom: "4px" }}
                            >
                              Email Id
                            </div>
                            <div className="small-dropdown">
                              <TextInput
                                placeholder=""
                                value={newEmail}
                                onChange={(e) => {
                                  const input = e.currentTarget.value;
                                  setNewEmail(input.trim());
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                    </>
                  )}
                </>
              )}

              <div>
                <Button
                  disabled={loading}
                  style={
                    loading
                      ? {
                          width: "100px",
                          height: "40px",

                          color: "#ffffff",
                          backgroundColor: "#c2c2c2",
                        }
                      : {
                          width: "100px",
                          height: "40px",

                          color: "#ffffff",
                          backgroundColor: "#ef7c01",
                        }
                  }
                  onClick={() => {
                    updatePatientInfo(patientInfo!);
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </Modal>
        </>
      )}
      {showPaymentLinkDialog && (
        <PaymentLinkDialog
          visible={showPaymentLinkDialog}
          onClose={() => {
            setPatientInfoForPayment(null);
            setAptSelectedForPayment(null);
            setShowPaymentLinkDialog(false);
          }}
          appointment={aptSelectedForPayment}
          profileDetails={patientInfoForPayment}
          refreshAptDetailScreenData={() => {
            getAppointments();
          }}
        />
      )}
    </div>
  );
}

export default ViewAppointments;
